import { BadgeProps } from "./types";
import { Container } from './styles';

export function  Badge({ children }: BadgeProps) {
  return <Container>{children}</Container>
}
